import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import { truncateString } from "../../../utils/truncate";
import { getCurrencySymbolWithoutISO } from "../../../utils/getCurrencySymbol";
import { Metafield } from "../../../lib/dynamicQueries/product";

const CURRENCY_CODE = process.env.GATSBY_LOCALE_CURRENCY;

const SearchProductCard = ({ hit }) => {
  return (
    <>
      <img
        src={hit.image ? `${hit.image}&height=520` : ''}
        alt={hit.title}
        className="w-full h-auto max-w-full rounded-lg mb-2"
      />
      <h5 className="max-h-[2.8em] mt-6 mb-1 font-bold text-ellipsis overflow-hidden">
        {hit.title}
      </h5>
      <p className="max-h-[2.8em] mb-1 text-ellipsis overflow-hidden text-[#9d9d9d] text-[10px] tracking-wide">
        {truncateString(hit.description, 85)}
      </p>
      {hit.clubPrice && hit.price === hit.comparePrice ? (
        <p className="font-bold text-sm lg:text-base tracking-wide">
          <span className="w-20">from {hit.clubPrice}</span>{" "}
          <del className="text-[10px] leading-4 tracking-wide font-normal text-[#c1c1c1]">{`${getCurrencySymbolWithoutISO(
            CURRENCY_CODE
          )}${Number(hit.price).toFixed(2)}`}</del>
        </p>
      ) : (
        <p className="font-bold text-sm lg:text-base tracking-wide">
          from{" "}
          {`${getCurrencySymbolWithoutISO(CURRENCY_CODE)}${Number(
            hit.price
          ).toFixed(2)}`}{" "}
          {hit.price !== hit.comparePrice && (
            <del className="text-[10px] leading-4 tracking-wide font-normal text-[#c1c1c1]">{`${getCurrencySymbolWithoutISO(
              CURRENCY_CODE
            )}${Number(hit.comparePrice).toFixed(2)}`}</del>
          )}
        </p>
      )}
    </>
  );
};

export default SearchProductCard;
